/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {
  email_right_grid: [],
  email_log_detail: [],
  email_list: [],
  save_payload_list: [],
  delete_payload_list: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.EMAIL_LIST:
      if (action.isRefreshData) {
        return {
          ...state,
          email_list: action.getEmailList,
        };
      } else {
        return {
          ...state,
          email_list: [...state.email_list, ...action.getEmailList],
        };
      }
    case actiontypes.EMAIL_LIST_CHECK:
      return {
        ...state,
        email_list_check: action.getEmailListCheck,
      };
    case actiontypes.EMAIL_LOG_DETAIL:
      if (action.getEmailLogDetail.length != 0) {
        return {
          ...state,
          email_log_detail: [
            ...state.email_log_detail,
            ...action.getEmailLogDetail,
          ],
        };
      } else {
        return {
          ...state,
          email_log_detail: action.getEmailLogDetail,
        };
      }
    case actiontypes.EMAIL_LOG_RIGHT_GRID:
      if (action.getEmailLogRightGrid.length != 0) {
        return {
          ...state,
          email_right_grid: [
            ...state.email_right_grid,
            ...action.getEmailLogRightGrid,
          ],
        };
      } else {
        return {
          ...state,
          email_right_grid: action.getEmailLogRightGrid,
        };
      }
    case actiontypes.SAVE_EMAIL_LOG:
      return {
        ...state,
        save_email_log: action.saveEmailLog,
      };
    case actiontypes.ERROR_LEFT_RIGHT_GRID:
      return {
        ...state,
        error_left_right_tbl: action.errorLeftRightTbl,
      };
    case actiontypes.EMAIL_AVAILABLE_LIST:
      return {
        ...state,
        email_available_list: action.emailTypeAvailableList,
      };
    case actiontypes.SAVE_PAYLOAD_LIST:
      return {
        ...state,
        save_payload_list: action.savePayloadList,
      };
    case actiontypes.DELETE_PAYLOAD_LIST:
      return {
        ...state,
        delete_payload_list: action.deletePayloadList,
      };
    default:
      return state;
  }
};
export default reducer;
